import { useEffect } from "react";

import { useWindowFocus } from "@App/hooks/useWindowFocus";

export namespace useQueryPollingWhileWindowFocused {
  export interface Args {
    pollInterval: number;

    /** The loading value. */
    loading: boolean;

    /** The `refetch` function returned from `useQuery`. */
    refetch: () => void;

    /** The skip value. */
    skip: boolean;

    /** The `startPolling` function returned from `useQuery`. */
    startPolling: (pollInterval: number) => void;

    /** The `stopPolling` function returned from `useQuery`. */
    stopPolling: () => void;
  }
}

/**
 * Hook that enables polling for a given GraphQL query while the window is focused - and disables
 * polling while the window is not focused. This reduces network traffic to our server while the
 * user isn't literally focused on our application.
 *
 * See the [Apollo docs](https://www.apollographql.com/docs/react/data/queries/#polling) for details
 * about polling.
 */
export function useQueryPollingWhileWindowFocused({
  pollInterval,
  loading,
  refetch,
  skip,
  startPolling,
  stopPolling,
}: useQueryPollingWhileWindowFocused.Args): void {
  const { isWindowFocused } = useWindowFocus();

  useEffect(() => {
    if (!isWindowFocused || skip) {
      stopPolling();
    } else {
      // Refetch data immediately when the window is refocused.
      // if (!loading) {
      //     refetch?.();
      // }
      startPolling(pollInterval);
    }
  }, [isWindowFocused, pollInterval, refetch, startPolling, stopPolling]);
}
